import type { InboundEmailDTO } from 'src/types/application/InboundEmailDTO';

type SignedAttachment = NonNullable<InboundEmailDTO['attachments']>[number];

/**
 * The signed attachment to show, or null when it has no URL to show.
 *
 * Looks in the split documents too: a file a reviewer unzipped onto the email
 * carries the zip as its parent, and the email read files every such document
 * under `splitAttachments` rather than `attachments`.
 */
export function viewableAttachment(
  email: Pick<InboundEmailDTO, 'attachments' | 'splitAttachments'> | undefined,
  attachmentId: string,
): SignedAttachment | null {
  const found = [
    ...(email?.attachments ?? []),
    ...(email?.splitAttachments ?? []),
  ].find((a) => a.id === attachmentId);
  return found?.s3Url ? found : null;
}
